/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_No_Presets_ToastInputs */

const en_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No presets to export`)
};

const fr_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun preset a exporter`)
};

const de_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen zum Exportieren`)
};

const it_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset da esportare`)
};

const ru_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет предустановок для экспорта`)
};

const es_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ajustes preestablecidos para exportar`)
};

const zh_cn2_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有预设要导出`)
};

const ja_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートするプリセットがありません`)
};

const hi_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात करने के लिए कोई प्रीसेट नहीं हैं`)
};

const pt_pt2_preset_manager_no_presets_toast = /** @type {(inputs: Preset_Manager_No_Presets_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há predefinições para exportar.`)
};

/**
* | output |
* | --- |
* | "No presets to export" |
*
* @param {Preset_Manager_No_Presets_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_no_presets_toast = /** @type {((inputs?: Preset_Manager_No_Presets_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_No_Presets_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_no_presets_toast(inputs)
	if (locale === "de") return de_preset_manager_no_presets_toast(inputs)
	if (locale === "it") return it_preset_manager_no_presets_toast(inputs)
	if (locale === "ru") return ru_preset_manager_no_presets_toast(inputs)
	if (locale === "es") return es_preset_manager_no_presets_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_no_presets_toast(inputs)
	if (locale === "ja") return ja_preset_manager_no_presets_toast(inputs)
	if (locale === "hi") return hi_preset_manager_no_presets_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_no_presets_toast(inputs)
	return en_preset_manager_no_presets_toast(inputs)
});